import type { RequestInterface } from '~/common/types';
import {
  TicketRequest,
  TicketType,
  TicketTypeID,
  TicketTypeRequestCreate,
  TicketTypeRequestID,
  TicketTypeRequestReject,
} from '~/ticketWallet/types';
export class TicketTypesRequest implements RequestInterface {
  method = 'get';
  path = '/api/v1/ticket-types';
  headers: Record<string, any>;
  params?: Record<string, any>;

  constructor({
    token,
    params,
  }: {
    token: string;
    params?: Record<string, any>;
  }) {
    this.headers = {
      authorization: `Bearer ${token}`,
    };
    if (params) {
      this.params = {
        ...params,
      };
    }
  }
}

export class GetTicketTypeRequest implements RequestInterface {
  method = 'get';
  path: string;
  headers: Record<string, any>;
  params?: Record<string, any>;

  constructor({
    token,
    id,
    params,
  }: {
    token: string;
    id: TicketTypeID;
    params?: Record<string, any>;
  }) {
    this.path = `/api/v1/ticket-types/${id}`;
    this.headers = {
      authorization: `Bearer ${token}`,
    };
    if (params) {
      this.params = {
        ...params,
      };
    }
  }
}

export class UpdateTicketTypeRequest implements RequestInterface {
  method = 'patch';
  path: string;
  headers: Record<string, any>;
  data: Record<string, any>;

  constructor({
    token,
    ticketType,
  }: {
    token: string;
    ticketType: TicketType;
  }) {
    this.path = `/api/v1/ticket-types/${ticketType.ticketTypeID}`;
    this.headers = {
      authorization: `Bearer ${token}`,
    };
    this.data = {
      ...ticketType,
    };
  }
}

export class CreateTicketTypeRequest implements RequestInterface {
  method = 'post';
  path = '/api/v1/ticket-types';
  headers: Record<string, any>;
  data: Record<string, any>;

  constructor({
    token,
    ticketType,
  }: {
    token: string;
    ticketType: TicketType;
  }) {
    this.headers = {
      authorization: `Bearer ${token}`,
    };
    this.data = {
      ...ticketType,
    };
  }
}

export class DeleteTicketTypeRequest implements RequestInterface {
  method = 'delete';
  path: string;
  headers: Record<string, any>;

  constructor({ token, id }: { token: string; id: TicketTypeID }) {
    this.path = `/api/v1/ticket-types/${id}`;
    this.headers = {
      authorization: `Bearer ${token}`,
    };
  }
}

export class TicketTypeRequestsRequest implements RequestInterface {
  method = 'get';
  path = '/api/v1/ticket-type-requests';
  headers: Record<string, any>;
  params?: Record<string, any>;

  constructor({
    token,
    params,
  }: {
    token: string;
    params?: Record<string, any>;
  }) {
    this.headers = {
      authorization: `Bearer ${token}`,
    };
    if (params) {
      this.params = {
        ...params,
      };
    }
  }
}

export class SubmitTicketTypeRequestRequest implements RequestInterface {
  method = 'post';
  path = '/api/v1/ticket-type-requests';
  headers: Record<string, any>;
  data: Record<string, any>;

  constructor({
    token,
    ticketTypeRequest,
  }: {
    token: string;
    ticketTypeRequest: TicketTypeRequestCreate;
  }) {
    this.headers = {
      authorization: `Bearer ${token}`,
    };
    this.data = {
      ...ticketTypeRequest,
    };
  }
}

export class ApproveTicketTypeRequestRequest implements RequestInterface {
  method = 'patch';
  path: string;
  headers: Record<string, any>;

  constructor({ token, id }: { token: string; id: TicketTypeRequestID }) {
    this.path = `/api/v1/ticket-type-requests/${id}/approve`;
    this.headers = {
      authorization: `Bearer ${token}`,
    };
  }
}

export class RejectTicketTypeRequestRequest implements RequestInterface {
  method = 'patch';
  path: string;
  headers: Record<string, any>;
  data: TicketTypeRequestReject;

  constructor({
    token,
    id,
    ticketTypeRequest,
  }: {
    token: string;
    id: TicketTypeRequestID;
    ticketTypeRequest: TicketTypeRequestReject;
  }) {
    this.path = `/api/v1/ticket-type-requests/${id}/reject`;
    this.headers = {
      authorization: `Bearer ${token}`,
    };
    this.data = {
      ...ticketTypeRequest,
    };
  }
}

export class CreateTicketRequest implements RequestInterface {
  method = 'post';
  path: string;
  headers: Record<string, any>;
  data: Record<string, any>;

  constructor({
    token,
    userId,
    ticket,
  }: {
    token: string;
    userId: string;
    ticket: TicketRequest;
  }) {
    this.path = `/api/v1/tickets/user/${userId}`;
    this.headers = {
      authorization: `Bearer ${token}`,
    };
    this.data = {
      ...ticket,
    };
  }
}

export class GetTicketRequest implements RequestInterface {
  method = 'get';
  path: string;
  headers: Record<string, any>;
  params?: Record<string, any>;

  constructor({
    token,
    ticketId,
    params,
  }: {
    token: string;
    ticketId: string;
    params?: Record<string, any>;
  }) {
    this.path = `/api/v1/tickets/${ticketId}`;
    this.headers = {
      authorization: `Bearer ${token}`,
    };
    if (params) {
      this.params = {
        ...params,
      };
    }
  }
}

export class UpdateTicketRequest implements RequestInterface {
  method = 'patch';
  path: string;
  headers: Record<string, any>;
  data: Record<string, any>;

  constructor({
    token,
    ticketId,
    ticket,
  }: {
    token: string;
    ticketId: string;
    ticket: TicketRequest;
  }) {
    this.path = `/api/v1/tickets/${ticketId}`;
    this.headers = {
      authorization: `Bearer ${token}`,
    };
    this.data = {
      ...ticket,
    };
  }
}

export class DeleteTicketRequest implements RequestInterface {
  method = 'delete';
  path: string;
  headers: Record<string, any>;
  params?: Record<string, any>;

  constructor({
    token,
    ticketId,
    params,
  }: {
    token: string;
    ticketId: string;
    params?: Record<string, any>;
  }) {
    this.path = `/api/v1/tickets/${ticketId}`;
    this.headers = {
      authorization: `Bearer ${token}`,
    };
    if (params) {
      this.params = {
        ...params,
      };
    }
  }
}
